import React, { useEffect, useState } from "react";
import "./Slider.css";

import banner1 from "../../assets/Image/NewImages/Sam_banner4.jpg";
import banner2 from "../../assets/Image/NewImages/Sam_Banner2.jpeg";
import banner3 from "../../assets/Image/NewImages/Sam_banner3.jpg";

function Slider() {
  const slides = [banner1, banner2, banner3];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="banner-slider">
      <div
        className="banner-track"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <div className="banner-slide" key={index}>
            <img src={slide} alt={`banner-${index}`} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Slider;
